import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import useWindowSize from "./useWindowSize";

const SlidesContainer = styled.div`
  display: flex;
  width: 375px;
  height: 75px;
  /* @media screen and (max-width: 450px) {
    width: 450px;
    height: 230px;
  } */

  
  
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const CarouselControls = styled.div`
  display: flex;
  align-items: center;
  font-size: 2em;
  color: #afafaf;
`;

const CarouselButton = styled.button`
  height: 1.75rem;
  width: 1.75rem;
  border: 2px solid #4b4b4b;
  /* @media screen and (max-width: 768px) {
     height: 2.5rem;
     width: 2.5rem;
     border: 4px solid #4b4b4b;
   } */
  border-radius: 50rem;

  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: ${(props) => props.margin};
`;

const Divider = styled.line`
  stroke: #b9b9b9;
  stroke-width: 2px;
`;

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function CarouselContents({ children, centerVal, setCenterVal }) {
  const [cursor, setCursor] = useState(centerVal-2);
  const [jump, setJump] = useState(false); // When window needs to circle back
  const [animating, setAnimating] = useState(false); // When animation is going on
  const carouselRef = useRef(0);
  const count = React.Children.count(children);
  const size = useWindowSize();
  useEffect(() => {
    carouselRef.current.addEventListener("transitionend", onTransitionEnd);
    return () => {
      carouselRef.current && carouselRef.current.removeEventListener("transitionend", onTransitionEnd);
    };
  }, [cursor]);

        /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchEnd(e) {

        // if the user released on a different target, cancel!
        //if (startEl !== e.target) return;

        var swipeThreshold = parseInt(getNearestAttribute(startEl, 'data-swipe-threshold', '20'), 10); // default 20px
        var swipeTimeout = parseInt(getNearestAttribute(startEl, 'data-swipe-timeout', '500'), 10);    // default 500ms
        var timeDiff = Date.now() - timeDown;
        var eventType = '';
        var changedTouches = e.changedTouches || e.touches || [];

        console.log('end');
        console.log('xdiff ' + xDiff);

        if (Math.abs(xDiff) > Math.abs(yDiff)) { // most significant
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) {
                    eventType = 'swiped-left';
                    changeCursor(1);
                    console.log('swiped left');
                }
                else {
                    eventType = 'swiped-right';
                    changeCursor(-1);
                    console.log('swiped right');
                }
            }
        }
        else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
            if (yDiff > 0) {
                eventType = 'swiped-up';
            }
            else {
                eventType = 'swiped-down';
            }
        }

        if (eventType !== '') {

            var eventData = {
                dir: eventType.replace(/swiped-/, ''),
                touchType: (changedTouches[0] || {}).touchType || 'direct',
                xStart: parseInt(xDown, 10),
                xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
                yStart: parseInt(yDown, 10),
                yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
            };

            // fire `swiped` event event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent('swiped', { bubbles: true, cancelable: true, detail: eventData }));

            // fire `swiped-dir` event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent(eventType, { bubbles: true, cancelable: true, detail: eventData }));
        }

        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
    }

    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchStart(e) {

        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute('data-swipe-ignore') === 'true') return;

        startEl = e.target;
        console.log('start ' + e.target);

        timeDown = Date.now();
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
    }

    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */
    function handleTouchMove(e) {

        if (!xDown || !yDown) return;

        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;

        xDiff = xDown - xUp;
        yDiff = yDown - yUp;
    }

    /**
     * Gets attribute off HTML element or nearest parent
     * @param {object} el - HTML element to retrieve attribute from
     * @param {string} attributeName - name of the attribute
     * @param {any} defaultValue - default value to return if no match found
     * @returns {any} attribute value or defaultValue
     */
    function getNearestAttribute(el, attributeName, defaultValue) {

        // walk up the dom tree looking for attributeName
        while (el && el !== document.documentElement) {

            var attributeValue = el.getAttribute(attributeName);

            if (attributeValue) {
                return attributeValue;
            }

            el = el.parentNode;
        }

        return defaultValue;
    }

  if (typeof window.CustomEvent !== 'function') {

        window.CustomEvent = function (event, params) {

            params = params || { bubbles: false, cancelable: false, detail: undefined };

            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };

        window.CustomEvent.prototype = window.Event.prototype;
    }


    useEffect(() => {
      
      document.addEventListener('touchstart', handleTouchStart, false);
      document.addEventListener('touchmove', handleTouchMove, false);
      document.addEventListener('touchend', handleTouchEnd, false);

      return () => {
        
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }, [animating]);
    

    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var timeDown = null;
    var startEl = null;






  function onTransitionEnd() {
    setAnimating(false);
    // Reached end on right side
    if (cursor >= count) {
      setJump(true);
      setCursor(0);
      return;
    }
    // Reached end on left side
    else if (cursor <= -1) {
      setJump(true);
      setCursor(count - 1);
      return;
    }
  }

  function changeCursor(amount) {
    if (animating) {
      return;
    }
    setCursor(cursor + amount);
    if (centerVal + amount >= count) {
      setCenterVal(0);
    } else if (centerVal + amount < 0) {
      setCenterVal(count - 1);
    } else {
      setCenterVal(centerVal + amount);
    }
  }

  const oldCursor = usePrevious(cursor);

  useEffect(() => {
    if (cursor !== oldCursor && oldCursor !== undefined) {
      setAnimating(true);
    }

    if (jump) {
      setTimeout(() => {
        setAnimating(false);
        setJump(false);
      }, 1);
    }
  }, [cursor, jump, oldCursor]);

  function convertIndexToZIndex(currentVal) {
    // Calculates the next and previous values.
    // Has to account for the fact that next value can go from 9 to 0
    // ex: [..., 7, 8, 9, 0, 1, ...]
    const nextVal =
      centerVal + 1 >= count ? centerVal + 1 - count : centerVal + 1;
    const prevVal = centerVal - 1 < 0 ? count - centerVal - 1 : centerVal - 1;
    const nextNextVal =
      centerVal + 2 >= count ? centerVal + 2 - count : centerVal + 2;
    const prevPrevVal =
      centerVal - 2 < 0 ? count - -centerVal - 2 : centerVal - 2;
    // if (size.width <= 450) {
    //   if (currentVal === centerVal) {
    //     return { zIndex: 2, toTheLeft: false };
    //   } else {
    //     return { zIndex: -1, toTheLeft: null };
    //   }
    // } else if (size.width <= 768) {
    //   if (currentVal === centerVal) {
    //     return { zIndex: 2, toTheLeft: false };
    //   } else if (currentVal === prevVal) {
    //     return { zIndex: 1, toTheLeft: true };
    //   } else if (currentVal === nextVal) {
    //     return { zIndex: 1, toTheLeft: false };
    //   } else {
    //     return { zIndex: -1, toTheLeft: null };
    //   }
    // }
    if(false){
      
    } else {
      if (currentVal === centerVal) {
        return { zIndex: 2, toTheLeft: false };
      } else if (currentVal === prevVal) {
        return { zIndex: 1, toTheLeft: true };
      } else if (currentVal === nextVal) {
        return { zIndex: 1, toTheLeft: false };
      } else if (currentVal === prevPrevVal) {
        return { zIndex: 0, toTheLeft: true };
      } else if (currentVal === nextNextVal) {
        return { zIndex: 0, toTheLeft: false };
      } else return { zIndex: -1, toTheLeft: null };
    }
  }

  function renderChildren() {
    const amendedChildren = [].concat(children, children, children);

    return amendedChildren.map((child, index) => {
      const currentVal = child.props.val - 1;
      return React.cloneElement(child, {
        key: index,
        zIndex: convertIndexToZIndex(currentVal).zIndex,
        toTheLeft: convertIndexToZIndex(currentVal).toTheLeft
      });
    });
  }

  const carouselSlideWidth = 75;

  const style = {
    display: "flex",
    transition: jump ? "none" : "all 300ms ease",
    transform: `translateX(${(count + cursor) * carouselSlideWidth * -1}px)`
  };

  return (
    <>
      <SlidesContainer>
        <div style={style} ref={carouselRef}>
          {renderChildren()}
        </div>
      </SlidesContainer>

      <div className="carouselButton">
      <CarouselControls style={{padding:"10px"}}>
        <CarouselButton margin="0 0.75em 0 0" onClick={() => changeCursor(-1)}>
          <FontAwesomeIcon
            icon={faAngleLeft}
            style={{ height: "100%", width: "auto", color: "#4b4b4b" }}
          />
        </CarouselButton>
        
        <CarouselButton margin="0 0 0 0.75rem" onClick={() => changeCursor(1)}>
          <FontAwesomeIcon
            icon={faAngleRight}
            style={{ height: "100%", width: "auto", color: "#4b4b4b" }}
          />
        </CarouselButton>
      </CarouselControls>
      </div>
    </>
  );
}
export default CarouselContents;
